// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5a380ab5","266":"bc9385aa","473":"30b62635","557":"d77e7785","608":"d26275d9","661":"3fcf06a5","665":"253d9d82","704":"54d19427","848":"31142558","898":"38cfc519","942":"bd53c6c9","963":"30aab181"}[chunkId] + ".chunk.js";
};